import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../../stores/redux.store';
import hasNoInjectedServerState from '../../../../../utilities/has-no-injected-server-state';
import {
  usePageState,
  isRedirectResult,
  BasePageState,
  BaseRedirectState,
  isPageStateResult,
  isSasStateEndpointEnabled,
} from '../../../../../utilities/hooks/usePageState';
import { verifyEmailOtpSetState } from '../../../../../actions/verify-email-otp-actions';
import { useNavigateSoftOrHard } from '../../../../../utilities/hooks/useNavigateSoftOrHard';

export type SignupVerifyEmailOtpStateResult = BaseRedirectState | SignupVerifyEmailOtpPageState;

export interface SignupVerifyEmailOtpPageState extends BasePageState {
  email: string;
  csrfToken: string;
}

const usePreloadedState = () => {
  const { email } = useAppSelector(state => state.verifyEmailOtp);
  return { email };
};

export const useSignupVerifyEmailOtpState = () => {
  const noServerState = isSasStateEndpointEnabled() && hasNoInjectedServerState();
  const dispatch = useAppDispatch();
  const navigate = useNavigateSoftOrHard();

  const {
    state: stateFromApi,
    isLoading,
    isError,
    error,
  } = usePageState('/signup/verify-email/otp/state', {
    enabled: noServerState,
  });

  useEffect(() => {
    if (isPageStateResult(stateFromApi)) {
      dispatch(verifyEmailOtpSetState(stateFromApi));
    }
  }, [dispatch, stateFromApi]);

  const preloadedState = usePreloadedState();

  if (isRedirectResult(stateFromApi)) {
    navigate(stateFromApi.uri);

    return {
      state: undefined,
      isLoading: true,
      isError: false,
    };
  }

  if (noServerState) {
    return {
      state: stateFromApi,
      isLoading,
      isError,
      error,
    };
  }

  return {
    state: preloadedState,
    isLoading: false,
    isError: false,
    error,
  };
};
